import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.clients.ClientUiAdaptor.';
  public static readonly openingClient = `${Id.prefix}openingClient`;
  public static readonly pleaseWaitWhileConstructingClient = `${Id.prefix}pleaseWaitWhileConstructingClient`;
}

export class LangDealerFranchiseeClientUiAdaptor {
  private constructor() {}
  public static openingClient(): string {
    return interpolate(Id.openingClient);
  }
  public static pleaseWaitWhileConstructingClient(): string {
    return interpolate(Id.pleaseWaitWhileConstructingClient);
  }
}

export class DealerFranchiseeClientUiAdaptorModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.openingClient, "Opening {{glossary 'client'}}", 'Modal message shown while opening a client');
    register.add(
      Id.pleaseWaitWhileConstructingClient,
      "Please wait while we construct the {{glossary 'client'}}",
      'Modal message shown while constructing a client'
    );
  }
}
